import { PlannedRouteTrail } from 'atlasguides-web-common/src/functions/guides/dto/guide-geo.dto';
import { DistanceUnitInfo, ElevationUnitInfo } from 'commonTypes/CommonStore/distanceUnits';
import { GuideGeoExt, PlannedRouteExt, PlannedRoutePinInfo } from 'commonTypes/GuideUse/guideGeo';
import { GeoRouteBuilder } from 'services/Navigation/GeoRouteBuilder/GeoRouteBuilder';
import { TrailPoint } from 'services/Navigation/RouteTree';


export const getPlannedRouteById = (id: string, plannedRoutes: PlannedRouteExt[]): PlannedRouteExt | null => {
    for (let i = 0; i < plannedRoutes.length; i++) {
        if (plannedRoutes[i].id === id) {
            return plannedRoutes[i];
        }
    }
    return null;
}

export const getEnabledPlannedRoute = (plannedRoutes: PlannedRouteExt[]): PlannedRouteExt | null => {
    const routeId = getEnabledPlannedRouteId();
    if (routeId != null) {
        return getPlannedRouteById(routeId, plannedRoutes);
    }
    return null;
}

export const setEnabledPlannedRoute = (plannedRoute: PlannedRouteExt, plannedRoutes: PlannedRouteExt[], isEnabled: boolean ) => {
    localStorage.removeItem('selectedPlannedRoute');

    for (let i = 0; i < plannedRoutes.length; i++) {
        if (plannedRoutes[i].id === plannedRoute.id) {
            plannedRoutes[i].isEnabled = isEnabled;
            if (isEnabled){
                localStorage.setItem('selectedPlannedRoute', plannedRoutes[i].id);
            }
        }
        else{
            plannedRoutes[i].isEnabled = false;
        }
    }
}

export const checkNewTrailPointAllowed = (guide: GuideGeoExt, plannedRoute: PlannedRouteExt, newPoint: TrailPoint): boolean => {
    
    // Check duplication to the last point (Safari fix - the first click on the map is duplicated in Safari)
    if (plannedRoute.pinsInfo != null && plannedRoute.pinsInfo.length > 0){
        const lastPoint = plannedRoute.pinsInfo[plannedRoute.pinsInfo.length - 1];
        if (lastPoint.latitude === newPoint.latitude && lastPoint.longitude === newPoint.longitude) {
            return false;
        }
    }

    // Check direction
    const routeBuilder = new GeoRouteBuilder(guide, plannedRoute);
    const trail = routeBuilder.buildTrail();
    if (trail != null && plannedRoute.pinsInfo != null){
        const firstPoint = plannedRoute.pinsInfo[0];

        let newPointInfo: PlannedRoutePinInfo = {
            pin: `${newPoint.latitude},${newPoint.longitude}`,
            latitude: newPoint.latitude,
            longitude: newPoint.longitude,
            trailName: "check",
            distance: 0,
            trailPoint: newPoint
        }
        const routeBuilder = new GeoRouteBuilder(guide, null);
        routeBuilder.setPinsInfo([firstPoint, newPointInfo]);
        const testTrail = routeBuilder.buildTrail();

        if (testTrail != null && testTrail.trackLengthDirection != null){
            const testTrailLength = testTrail.trackLengthDirection
            const origTrailLength = trail.trackLengthDirection ?? 0

            if ((origTrailLength ^ testTrailLength) < 0){
                return false;
            }
            if (testTrailLength > 0 && testTrailLength <= origTrailLength){
                return false;
            }
            if (testTrailLength < 0 && testTrailLength >= origTrailLength){
                return false;
            }
        }
    }
    return true;
}   

export const updatePlannedRouteInfoByTrail = (plannedRoute: PlannedRouteExt, pins: PlannedRoutePinInfo[], trail: PlannedRouteTrail | null) => {
  
    plannedRoute.trail = trail;

    plannedRoute.routeLength = trail?.trackLength ?? 0;

    plannedRoute.totalAscent = trail?.totalAscent ?? 0;
    plannedRoute.totalDescent = trail?.totalDescent ?? 0;

    if (pins && pins.length > 0){
        plannedRoute.pinsInfo = pins;
    }
    else{
        plannedRoute.pinsInfo = [];
    }
}

export const findPlannedRouteById = (routeId: string, plannedRoutes: PlannedRouteExt[]) => {
    for (let i = 0; i < plannedRoutes.length; i++) {
        if (plannedRoutes[i].id === routeId) {
            return plannedRoutes[i]
        }
    }
    return null
}
export const findPlannedRouteByUniqueId = (uniqueId: string, plannedRoutes: PlannedRouteExt[]) => {
    for (let i = 0; i < plannedRoutes.length; i++) {
        if (plannedRoutes[i].uniqueId === uniqueId) {
            return plannedRoutes[i]
        }
    }
    return null
}

export const getEnabledPlannedRouteId = (): string | null => {
    return localStorage.getItem('selectedPlannedRoute')
}

export const getTotalGrade = (plannedRoute: PlannedRouteExt, actualDistanceUnit: DistanceUnitInfo, actualElevationUnit: ElevationUnitInfo): Number => {
    let asc = ((plannedRoute.trail?.totalAscent ?? plannedRoute.totalAscent ?? 0) / actualElevationUnit.valueInMeters)
    let desc = ((plannedRoute.trail?.totalDescent ?? plannedRoute.totalDescent ?? 0) / actualElevationUnit.valueInMeters)
    let totalLength = ((plannedRoute.trail?.trackLength ?? plannedRoute.routeLength ?? 0) / actualDistanceUnit.valueInMeters)
    return (asc + desc) / totalLength;
}
